import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	NgZone,
	ViewRef
}
from '@angular/core';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-service-page/phieu-thong-tin-hang-ve.service';
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DeNghiNhapKhoChiTiet, DenghinhapkhoLsthaotac } from '../phieu-thong-tin-hang-ve-model-page/phieu-thong-tin-hang-ve.model';

@Component({
	selector: 'm-pb-pass-hang-dialog',
	templateUrl: './pb-pass-hang-dialog.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class PBPassHangDialogComponent implements OnInit{

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* ------------------- Các form trên dialog --------------------------*/
	ThongTinHangVeCTForm: FormGroup;				
	KiemTraPassHangForm: FormGroup;
	PBXacNhanForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/*-------------------- Mat select search cho kho ---------------------*/
	listKhoVer2 : any[] = [];
	selectKhoVer2 : string = '';
	filteredKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrlVer2: string = '';
	haveElementKhoVer2: boolean = false;
	/* ------------------------------------------------------------------ */

	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	thongTinHangVeCTItem: DeNghiNhapKhoChiTiet;
	thongTinHangVeLSList: DenghinhapkhoLsthaotac[] = [];
	/* ------------------------------------------------------------------ */

	/*------------------------- Extend field: ----------------------------*/
	title: string = '';	
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.	
	previousIndex: number; 				 // Lưu lại vị trí trước đó khi swap các cột trên lưới
	saveAdded: number[] = []		     // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	 // Loading khi mở dialog
	listOptionKetQua: any[] = []
	disableButton: boolean = false;
	isChange: boolean = false;
	minDate: any;	
	isNhapKhoNoiBo: boolean = false;
	isDisable: boolean = false
	isDetail: boolean = false;
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<PBPassHangDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private dungChungService : DungChungService,
		private ThongTinHangVeCTFB: FormBuilder,
		private KiemTraPassHangFB: FormBuilder,
		private PBXacNhanFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
	) {
		this.dialogRef.disableClose = true;
	}


	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Get data from list when open dialog */
		this.ListKhoVer2();
		this.thongTinHangVeCTItem = this.data.data;
		this.thongTinHangVeLSList = this.data.ls;
		this.isDetail = this.data.isDetail;
		
		let tmpListKetQua = DeNghiNhapKhoChiTiet.optionQuyetDinhLoHang;
		tmpListKetQua.forEach(x => {
			if(x.value != 1){
				this.listOptionKetQua.push(x)
			}
		})
	
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Load all dropdown and create form */
		this.createForm();
		this.title = this.getTitle();

		this.KiemTraPassHangForm.get('PassNhap').valueChanges.subscribe( newValue =>{
		   if(newValue == "0"){
				this.KiemTraPassHangForm.controls["KhoNhap"].setValue('');
				this.KiemTraPassHangForm.controls["KhoNhap"].disable();

				this.KiemTraPassHangForm.controls["KhoNhap"].setValidators([]);
				this.KiemTraPassHangForm.controls['KhoNhap'].updateValueAndValidity()
		   }
		   if(newValue == "1"){
				this.KiemTraPassHangForm.controls["KhoNhap"].enable();
				this.KiemTraPassHangForm.controls["KhoNhap"].setValidators([Validators.required]);
				this.KiemTraPassHangForm.controls['KhoNhap'].updateValueAndValidity()
				this.isNhapKhoNoiBo = false;
		   }
		})

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			
			if (event.key == "Escape") {
				this.back();
			}
		});

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form and handle event on form-- ---------------*/
	createForm(){
		/*Group các Form */
		this.ThongTinHangVeCTForm = this.ThongTinHangVeCTFB.group({
			MaHH: [this.thongTinHangVeCTItem.MaHH],
			TenHH: [this.thongTinHangVeCTItem.TenHH],
			QuyCach: [this.thongTinHangVeCTItem.QuyCach],
			TenDVT: [this.thongTinHangVeCTItem.TenDVT],
			SoLo: [this.thongTinHangVeCTItem.Solo],
			SLKehoach: [this.f_number(this.thongTinHangVeCTItem.Soluongkehoach)],
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeCTForm.disable();
	
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var tomorrow = new Date();
		tomorrow.setDate(new Date().getDate()+1);
		this.minDate = tomorrow;
		
		if(this.isDetail){
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
				NgayKiemTra: [(this.thongTinHangVeCTItem.Ngaykiemtra != null && this.thongTinHangVeCTItem.Ngaykiemtra != '' ) ? this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra) : ''],
				QuyetDinhLoHang: [this.thongTinHangVeCTItem.Quyetdinhlohang.toString()],
				LyDo: [this.thongTinHangVeCTItem.GhiChuKetQuaKiemTra],
				SLThucNhap: [this.f_number((this.thongTinHangVeCTItem.SoLuongThucNhap))],
				HSD: [(this.thongTinHangVeCTItem.Handung != null && this.thongTinHangVeCTItem.Handung != '' ) ? this.thongTinHangVeCTItem.Handung : ''],
				PassNhap: [(this.thongTinHangVeCTItem.TrangThaiNhapKho - 1).toString()],
				KhoNhap: [(this.thongTinHangVeCTItem.id_kho) == null ? '' : (this.thongTinHangVeCTItem.id_kho).toString() ]
			});
			this.KiemTraPassHangForm.disable();

			this.PBXacNhanForm = this.PBXacNhanFB.group({
				NguoiXacNhan: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,2)],
				NgayXacNhan: [this.getFormatDate(this.getHistory(this.thongTinHangVeCTItem.IdCtdn,3))],
				KetQUaDuyet: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,0)],
				LyDo: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,1)]
			})
	
			/*Disable các trường dữ liệu không thay đổi */
			this.PBXacNhanForm.disable();
		}
		else{
			
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [tenNguoiLap],
				NgayKiemTra: [this.getFormatDate(moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS'))],
				QuyetDinhLoHang: [DeNghiNhapKhoChiTiet.optionQuyetDinhLoHang[0].value.toString()],
				LyDo: [],
				SLThucNhap:[DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE, Validators.compose([Validators.required, 
																							//Validators.min(0.01),
																							Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
				],
				HSD: [this.minDate],
				PassNhap: ['0'],
				KhoNhap: ['']
			});

			this.KiemTraPassHangForm.controls["NguoiKiemTra"].disable();
			this.KiemTraPassHangForm.controls["NgayKiemTra"].disable();
			this.KiemTraPassHangForm.controls["KhoNhap"].disable();
			var idUser = '';
			this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
			this.thongTinHangVeCTItem.Nguoikiemtra = +idUser;
		}
		this.changeDetectView();
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	getTitle(): string {
		return `Thông tin PB pass hàng`;
	}
	getHistory(idDetail: any, type: number){
		let item = this.thongTinHangVeLSList.find(x => x.DeNghiNhapKhoCtId == idDetail 
												&& x.LoaiThaoTac == (DeNghiNhapKhoChiTiet.optionTrangThaiDetail[6].value
													+ "-" + DeNghiNhapKhoChiTiet.optionTrangThaiDetail[4].value))
	
		if(item != null && type == 0){
			return item.NoiDung
		}
		else if(item != null && type == 1){
			return item.GhiChu;
		}
		else if(item != null && type == 2){
			return item.TenNguoiThaoTac;
		}
		else if(item != null && type == 3){
			return item.NgayThaoTac;
		}
		return '';
	}
	ListKhoVer2(){
		this.dungChungService.listKhoTheoQuyen().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoVer2 = res.data;
				this.filteredKhoVer2.next(this.listKhoVer2.slice());
				this.changeDetectView();
			};
		});
	}
	filterListKhoVer2() {
		if (!this.listKhoVer2) {
			return;
		}
		let search = this.KhoFilterCtrlVer2;
		if (!search) {
			this.filteredKhoVer2.next(this.listKhoVer2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoVer2.next(
			this.listKhoVer2.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	isTraHang(){
		return +this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value == this.listOptionKetQua[1].value;
	}
	changeKetQuaPassHang(){
		this.KiemTraPassHangForm.enable();
		if(+this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value == this.listOptionKetQua[0].value){
			this.KiemTraPassHangForm.controls["SLThucNhap"].setValidators([Validators.required, 
																			// Validators.min(0.01),
																			Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)]);
			this.KiemTraPassHangForm.controls['SLThucNhap'].updateValueAndValidity()

			this.KiemTraPassHangForm.controls["LyDo"].setValidators([]);
			this.KiemTraPassHangForm.controls['LyDo'].updateValueAndValidity()

			this.KiemTraPassHangForm.controls["NguoiKiemTra"].disable();
			this.KiemTraPassHangForm.controls["NgayKiemTra"].disable();
		}

		else if(+this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value == this.listOptionKetQua[1].value){
			this.KiemTraPassHangForm.controls["LyDo"].setValidators([Validators.required]);
			this.KiemTraPassHangForm.controls['LyDo'].updateValueAndValidity()

			this.KiemTraPassHangForm.controls["SLThucNhap"].setValidators([Validators.min(0.00),
								Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)]);
			this.KiemTraPassHangForm.controls['SLThucNhap'].updateValueAndValidity()

			this.KiemTraPassHangForm.controls["NguoiKiemTra"].disable();
			this.KiemTraPassHangForm.controls["NgayKiemTra"].disable();
		
		}
		if(this.KiemTraPassHangForm.controls["PassNhap"].value == "0"){
			this.KiemTraPassHangForm.controls["KhoNhap"].setValue('');
			this.KiemTraPassHangForm.controls["KhoNhap"].disable();

			this.KiemTraPassHangForm.controls["KhoNhap"].setValidators([]);
			this.KiemTraPassHangForm.controls['KhoNhap'].updateValueAndValidity()
	   }
	   if(this.KiemTraPassHangForm.controls["PassNhap"].value == "1"){
			this.KiemTraPassHangForm.controls["KhoNhap"].enable();
			this.KiemTraPassHangForm.controls["KhoNhap"].setValidators([Validators.required]);
			this.KiemTraPassHangForm.controls['KhoNhap'].updateValueAndValidity()
			this.isNhapKhoNoiBo = false;
	   }
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
				
			}else{
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			}else{
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){
		
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.f_number(event.target.value.toString());

			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = tmpValue.toString();
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			item[columnName] =tmpValue.toString();
		}
		else{
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/

	
	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		this.dialogRef.close(
			{ isChange: this.isChange,}
		);
	}
	saveItem(){
		const controls = this.KiemTraPassHangForm.controls;

		if (this.KiemTraPassHangForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		const _deleteMessage = `Lưu kết quả pass hàng thành công`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.thongTinHangVeCTItem.Nguoikiemtra = +this.thongTinHangVeCTItem.Nguoikiemtra;
			this.thongTinHangVeCTItem.Ngaykiemtra = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.thongTinHangVeCTItem.Quyetdinhlohang = +this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value;
			this.thongTinHangVeCTItem.GhiChuKetQuaKiemTra = this.KiemTraPassHangForm.controls["LyDo"].value;
			this.thongTinHangVeCTItem.SoLuongThucNhap = this.KiemTraPassHangForm.controls["SLThucNhap"].value;
			this.thongTinHangVeCTItem.Handung = this.KiemTraPassHangForm.controls["HSD"].value;
			this.thongTinHangVeCTItem.TrangThaiNhapKho = this.KiemTraPassHangForm.controls["PassNhap"].value == '0' ? 1 : 2;
			this.thongTinHangVeCTItem.id_kho = +this.KiemTraPassHangForm.controls["KhoNhap"].value;
			this.thongTinHangVeCTItem.SoLuongThucNhap = this.f_number(this.thongTinHangVeCTItem.SoLuongThucNhap);
			this.thongTinHangVeCTItem.isNhapKhoNoiBo = this.isNhapKhoNoiBo

			this.thongTinHangVeService.PBKiemTraHang(this.thongTinHangVeCTItem).subscribe(res => {
				if (res.status == 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.KiemTraPassHangForm.disable();
					this.disableButton = true;
					this.isChange = true;
					this.isDisable = true;
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});	
		});
	}
	/* -----------------------------------------------------------------------*/
	

	/*------------------------------ Extend Options --------------------------*/
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/
}